import React, { useEffect } from 'react';
import { Form } from 'antd';
import { useTranslation } from 'react-i18next';
import { IconSvg } from 'shared/icon';
import { StyledModal } from 'components/styledComponents/modal/Modal.styled';
import { authApi } from 'app/auth/api';
import { Buttons } from 'shared/button';
import { StyledIconDefault } from 'shared/icon/Icon.styled';
import ChangePasswordForm from './ChangePasswordForm';

const { useChangePasswordMutation } = authApi;

interface ChangePasswordProps {
  visible: boolean;
  changeModalState: () => void;
  changeEndedStatus: (status: boolean) => void;
  endedStatus: boolean;
}

const ChangePassword = ({
  visible,
  changeModalState,
  changeEndedStatus,
  endedStatus,
}: ChangePasswordProps) => {
  const [changePassword] = useChangePasswordMutation();

  const { t } = useTranslation();

  const [form] = Form.useForm();

  const onSave = () => {
    form.validateFields().then((values) => {
      changePassword(values);
    });
  };

  useEffect(() => {
    if (endedStatus) {
      changeModalState();
      changeEndedStatus(false);
    }
  }, [changeEndedStatus, changeModalState, endedStatus]);

  return (
    <StyledModal
      getContainer=".ant-layout-content"
      maskClosable={false}
      destroyOnHidden
      title={t('changePassword')}
      closable
      centered
      wrapClassName="account-modal-change-password"
      onCancel={changeModalState}
      closeIcon={(
        <StyledIconDefault>
          <IconSvg icon="CloseModalIcon" height="0.86rem" width="0.86rem" />
        </StyledIconDefault>
      )}
      open={visible}
      footer={<Buttons okText="update" onDiscard={changeModalState} onApply={onSave} size="large" />}
    >
      <ChangePasswordForm form={form} />
    </StyledModal>
  );
};

export default ChangePassword;
